<template>
  <div :class="{ 'h-24 load load--fill': loadingAcceptedShares }">
    <div
      v-if="pendingShares.data.length"
      v-can="'edit-documents'"
      class="py-8 bg-grey-lighter max-w-3xl flex-no-grow"
    >
      <div>
        <h3 v-text="'New Documents Have Been Shared With You'" />
        <div class="flex flex-wrap items-stretch">
          <PendingShare
            v-for="pendingShare in pendingShares.data"
            :key="pendingShare.uuid"
            :pending-share="pendingShare"
            @sharedItemHasBeenApproved="sharedItemHasBeenApproved"
          />
        </div>
      </div>
      <RejectSharedItemModal @sharedItemHasBeenRejected="getPendingShares" />
    </div>
    <div>
      <div
        v-if="folderHasContents"
        class="table-responsive"
      >
        <table class="table table-files min-w-table">
          <thead>
            <tr>
              <th
                colspan="7"
                class="table-caption"
              >
                <h2 v-text="'Shared documents'" />
              </th>
            </tr>
            <tr>
              <!--<th></th>-->
              <th v-text="'Name'" />
              <th v-text="'Modified'" />
              <th
                v-can="'edit-documents'"
                v-text="'Member Visibility'"
              />
              <th />
              <th v-can="'edit-documents'" />
            </tr>
          </thead>
          <tbody>
            <tr
              is="SharedDocumentRow"
              v-for="sharedItem in acceptedShares.data"
              :key="sharedItem.uuid"
              :document="sharedItem.item"
              :show-actions="true"
            />
          </tbody>
        </table>
      </div>
      <div
        v-if="!loadingAcceptedShares && !folderHasContents"
        class="empty"
      >
        <section>
          <h2 v-text="'No documents have been shared with you'" />
          <p>Here you will find documents shared to you by an admin from another organization.</p>
        </section>
      </div>
    </div>
    <SendToMembershipGroupsModal
      :shared-item-mode="true"
      @resourceHasBeenSentToMembershipGroups="getAcceptedShares"
    />
    <SendToMembershipsModal
      :shared-item-mode="true"
      @resourceHasBeenSentToMemberships="getAcceptedShares"
    />
  </div>
</template>

<script type="text/babel">
import PendingShare from './PendingDocumentShare'
import RejectSharedItemModal from './_modals/RejectSharedItemModal'
import SharedDocumentRow from './SharedDocumentRow'
import SendToMembershipGroupsModal from './_modals/SendToMembershipGroupsModal'
import SendToMembershipsModal from './_modals/SendToMembershipsModal'

export default {
  name: 'SharedDocuments',
  components: {
    PendingShare,
    SharedDocumentRow,
    SendToMembershipGroupsModal,
    SendToMembershipsModal,
    RejectSharedItemModal,
  },
  data() {
    return {
      loadingPendingShares: false,
      pendingShares: {
        data: [],
      },
      loadingAcceptedShares: false,
      acceptedShares: {
        data: [],
      },
    }
  },
  computed: {
    folderHasContents() {
      return this.acceptedShares.data.length
    },
  },
  async mounted() {
    await this.$nextTick()

    this.getPendingShares()
    this.getAcceptedShares()
  },
  methods: {
    sharedItemHasBeenApproved() {
      this.getAcceptedShares()
      this.getPendingShares()

      this.$store.dispatch('documentGetPendingShareCounts')
    },
    getAcceptedShares() {
      this.loadingAcceptedShares = true

      this.$api.active().get('shares/accepted?type=document')
        .then((response) => {
          this.acceptedShares = response.data
          this.loadingAcceptedShares = false
        })
    },
    getPendingShares() {
      this.loadingPendingShares = true

      this.$api.active().get('shares/pending?type=document')
        .then((response) => {
          this.loadingPendingShares = false
          this.pendingShares = response.data
        })
    },
  },
}
</script>
